import { useState, useEffect, useRef } from 'react';
import { Message } from '@base/lib/Message';
import { loadMonkeyProducts } from 'base/utils/tracker';
import { IGetListParams, IListPage } from 'mod/product-list/interface';
import { getListPage } from 'mod/product-list/service';

export type ListInstance = {
    pageData: IListPage | null;
    params: IGetListParams;
    loading: boolean;
    getPage: (page: number, newParams?: IGetListParams) => Promise<IListPage | null>;
    resetCounter: number;
    isAutoLoad?: boolean;
};

export default function useClientList(props: IGetListParams, isAutoLoad: boolean = false): ListInstance {
    const { listSn } = props;
    const [params, setParams] = useState<IGetListParams>(props);
    const [pageData, setPageData] = useState<IListPage | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [resetCounter, setResetCounter] = useState<number>(0);
    const counterRef = useRef<number>(0); // api abort hack

    const getPage = async (page: number, newParams?: IGetListParams) => {
        const _parmas = { ...(newParams || params), page };
        const counter = counterRef.current;
        setLoading(true);
        try {
            const res = await getListPage(_parmas);
            if (counter === counterRef.current) {
                if (res.page > 1) {
                    setPageData({ ...res, list: [...(pageData?.list || []), ...res.list] });
                } else {
                    setPageData(res);
                }
                setLoading(false);
                return res;
            }
        } catch (e) {
            Message.error(e.message);
            setLoading(false);
        }
        return null;
    };

    useEffect(() => {
        if (!listSn) {
            return;
        }
        counterRef.current = counterRef.current + 1;
        setParams({ ...props, page: 0 });
        setPageData(null);
        setResetCounter(counterRef.current);
        if (isAutoLoad) {
            getPage(1, props);
        }
    }, [listSn]);

    useEffect(() => {
        if(pageData?.list?.length) {
            loadMonkeyProducts();
        }
    }, [pageData]);

    return {
        pageData,
        params,
        loading,
        getPage,
        resetCounter
    };
}